import React, { useState, useEffect, useContext } from 'react';

import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import { green } from '@mui/material/colors';
import Fab from '@mui/material/Fab';
import CheckIcon from '@mui/icons-material/Check';
import SaveIcon from '@mui/icons-material/Save';
import EmailIcon from '@mui/icons-material/Email';
import InsertEmoticonIcon from '@mui/icons-material/InsertEmoticon';

import LoadingTailwindContext from '../../context/LoadingTailwindContext'
import LocationOnIcon from '@mui/icons-material/LocationOn';

import '../../Styles/LoadingTailwind.css'

function LoadingTailwindComp(props) {

    const [loading, setLoading] = useState(true);
    const [success, setSuccess] = useState(false);
    const [thinking, setThinking] = useState(false);
    const [location, setLocation] = useState(false);
    const [save, setSave] = useState(false);
    const [email, setEmail] = useState(false);

    const [dataLoadingTailwind, ] = useContext(LoadingTailwindContext);

    const buttonSx = {
        ...(success && {
            bgcolor: green[500],
            '&:hover': {
                bgcolor: green[700],
            },
        }),
    };

    useEffect(() => {

        setLoading(dataLoadingTailwind.loading);
        setSuccess(dataLoadingTailwind.success);
        setThinking(dataLoadingTailwind.thinking);
        setLocation(dataLoadingTailwind.location);
        setSave(dataLoadingTailwind.save);
        setEmail(dataLoadingTailwind.email);

    }, [dataLoadingTailwind]);


    return (
        <div>
            <div className="Container-tailwind">
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <Box sx={{ m: 1, position: 'relative' }}>
                        <Fab
                            aria-label="save"
                            color="primary"
                            sx={buttonSx}
                            className="icon-check"
                        >
                            {success ? <CheckIcon /> : null }
                            {thinking ? <InsertEmoticonIcon /> : null }
                            {location ? <LocationOnIcon /> : null }
                            {save ? <SaveIcon /> : null }
                            {email ? <EmailIcon /> : null }

                        </Fab>
                        {loading && (
                            <CircularProgress
                                size={68}
                                sx={{
                                    color: "rgb(132,50,155)",
                                    position: 'absolute',
                                    top: -6,
                                    left: -6,
                                    zIndex: 1,
                                }}
                            />
                        )}
                    </Box>
                </Box></div>
            <div className="Text-center">
                <label>{props.label}</label>
            </div> </div>
    )
}

export default LoadingTailwindComp;